import React, { Fragment, useState, useMemo } from 'react'
import classnames from 'classnames'
import {
  makeStyles,
  CircularProgress,
  IconButton,
  OutlinedInput,
  FormControl,
  Select,
  MenuItem,
  InputAdornment,
  Grow,
} from '@material-ui/core'
import DefaultProfilePicture from '../../../../../Assets/Images/default-profile-pic.png'
import { VisibilityOnIcon } from '../../../../../Assets/Images/icons/visibility-on'
import { VisibilityOffIcon } from '../../../../../Assets/Images/icons/visibility-off'
import { useHistory } from 'react-router-dom'
import { CameraIcon } from '../../../../../Assets/Images/icons/camera'
import { styles } from './styles'
import {
  validateUserProfile,
  PROFILE_FORM_INPUTS,
  requiredFields,
  handleImageUpdate,
} from './utils'
import { authorization } from '../../../../../Module/Auth/Auth'
import classNames from 'classnames'
import { FieldLabel } from '../../../../../Components/FieldLabel/FieldLabel'

const useStyles = makeStyles(() => styles)

export const CreateUserForm = ({ handleSave, saving, client = {} }) => {
  const user = authorization.getUser()
  const classes = useStyles()
  const history = useHistory()
  const [userData, setUserData] = useState({})
  const [errors, setErrors] = useState({})
  const [profilePicture, setProfilePicture] = useState(null)
  const [showPassword, setShowPassword] = useState(false)
  const [showPassword2, setShowPassword2] = useState(false)
  const [checkingEmail, setCheckingEmail] = useState(null)
  const [checkUserTimeout, setCheckUserTimeout] = useState(null)

  const disableSave = useMemo(
    () =>
      checkingEmail ||
      (!requiredFields.every(inputName => !!userData[inputName]) ||
        Object.values(errors).some(value => !!value)),
    [errors, userData, checkingEmail],
  )

  const hiddenFileInput = React.useRef(null)

  const handleImageButtonClick = event => {
    hiddenFileInput.current.click()
  }

  const handleFormChange = async e => {
    setUserData({ ...userData, [e.target.name]: e.target.value })
    await validateUserProfile(
      e,
      setErrors,
      errors,
      userData,
      checkUserTimeout,
      setCheckUserTimeout,
      setCheckingEmail,
      client,
    )
  }

  return saving ? (
    <div className={classes.loadingContainer}>
      <CircularProgress />
    </div>
  ) : (
    <Fragment>
      <div
        className={classNames(
          classes.infoContainer,
          'makeStyles-infoContainer',
        )}
      >
        <div
          className={classNames(classes.imageColumn, 'makeStyles-imageColumn')}
        >
          <div className={classes.imageContainer}>
            {profilePicture ? (
              <img
                className={classNames(classes.image, 'makeStyles-image')}
                src={profilePicture}
                alt="profile"
              />
            ) : (
              <img
                className={classes.image}
                src={DefaultProfilePicture}
                alt="profile"
                cypress_id={'userAvatar'}
              />
            )}

            <IconButton
              className={classes.cameraIcon}
              onClick={handleImageButtonClick}
            >
              <CameraIcon />
              <input
                type="file"
                accept=".jpg, .jpeg, .png"
                ref={hiddenFileInput}
                onChange={event =>
                  handleImageUpdate({
                    event,
                    setUserData,
                    userData,
                    setProfilePicture,
                  })
                }
                style={{ display: 'none' }}
              />
            </IconButton>
          </div>
        </div>
        <div className={classes.info}>
          <div className={classNames(classes.row, 'makeStyles-row')}>
            <div
              className={classnames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <FieldLabel
                label="First Name"
                mandatory
                cypress_id="firstNameInputTitle"
              />
              <OutlinedInput
                className={classes.value}
                value={userData.firstName}
                name={PROFILE_FORM_INPUTS.FIRST_NAME}
                onChange={e => handleFormChange(e)}
                error={!!errors[PROFILE_FORM_INPUTS.FIRST_NAME]}
                cypress_id={'firstNameInput'}
              />
              <Grow in={!!errors[PROFILE_FORM_INPUTS.FIRST_NAME]}>
                <span className={classes.error}>
                  {errors[PROFILE_FORM_INPUTS.FIRST_NAME]}
                </span>
              </Grow>
            </div>
            <div
              className={classnames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <FieldLabel
                label="Last name"
                mandatory
                cypress_id="lastNameInputTitle"
              />
              <OutlinedInput
                className={classes.value}
                value={userData.lastName}
                name={PROFILE_FORM_INPUTS.LAST_NAME}
                onChange={e => handleFormChange(e)}
                error={!!errors[PROFILE_FORM_INPUTS.LAST_NAME]}
                cypress_id={'lastNameInput'}
              />
              <Grow in={!!errors[PROFILE_FORM_INPUTS.LAST_NAME]}>
                <span className={classes.error}>
                  {errors[PROFILE_FORM_INPUTS.LAST_NAME]}
                </span>
              </Grow>
            </div>
            <div
              className={classnames(classes.infoItem, 'makeStyles-infoItem')}
            >
              {' '}
            </div>
          </div>

          <div className={classNames(classes.row, 'makeStyles-row')}>
            <div
              className={classnames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <FieldLabel
                label="Company"
                mandatory
                cypress_id="companyFieldTitle"
              />
              <OutlinedInput
                className={classes.value}
                value={(user.client && user.client.name) || '-'}
                disabled
                cypress_id={'companyField'}
              />
            </div>

            <div
              className={classnames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <FieldLabel label="Role" mandatory cypress_id="roleInputTitle" />
              <FormControl variant="outlined" className={classes.formControl}>
                <Select
                  value={userData.role}
                  name={PROFILE_FORM_INPUTS.ROLE}
                  onChange={handleFormChange}
                  className={classes.value}
                  cypress_id={'roleInput'}
                >
                  <MenuItem value="ROLE_CLIENT" className={classes.value}>
                    User
                  </MenuItem>
                  <MenuItem value="CLIENT_ADMIN" className={classes.value}>
                    Admin
                  </MenuItem>
                </Select>
              </FormControl>
              <Grow in={!!errors[PROFILE_FORM_INPUTS.ROLE]}>
                <span className={classes.error}>
                  {errors[PROFILE_FORM_INPUTS.ROLE]}
                </span>
              </Grow>
            </div>

            <div
              className={classnames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <FieldLabel
                label="Password"
                mandatory
                cypress_id="passwordInputTitle"
              />
              <OutlinedInput
                className={classes.value}
                value={userData.password}
                name={PROFILE_FORM_INPUTS.PASSWORD}
                type={showPassword ? 'text' : 'password'}
                onChange={handleFormChange}
                inputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword(!showPassword)}
                      edge="end"
                    >
                      {showPassword ? (
                        <VisibilityOnIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                cypress_id={'passwordInput'}
              />
              <Grow in={!!errors[PROFILE_FORM_INPUTS.PASSWORD]}>
                <span className={classes.error}>
                  {errors[PROFILE_FORM_INPUTS.PASSWORD]}
                </span>
              </Grow>
            </div>
          </div>

          <div className={classNames(classes.row, 'makeStyles-row')}>
            <div
              className={classnames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <FieldLabel
                label="Email address"
                mandatory
                cypress_id="emailInputTitle"
              />

              <OutlinedInput
                className={classes.value}
                value={userData.email}
                name={PROFILE_FORM_INPUTS.EMAIL}
                onChange={e => handleFormChange(e)}
                error={!!errors[PROFILE_FORM_INPUTS.EMAIL]}
                cypress_id={'emailInput'}
              />
              <Grow in={!!errors[PROFILE_FORM_INPUTS.EMAIL]}>
                <span className={classes.error}>
                  {errors[PROFILE_FORM_INPUTS.EMAIL]}
                </span>
              </Grow>
            </div>
            <div
              className={classnames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <FieldLabel
                label="Business phone number"
                mandatory
                cypress_id="businessPhoneNumberInputTitle"
              />
              <OutlinedInput
                className={classes.value}
                value={userData.mobilePhone}
                name={PROFILE_FORM_INPUTS.PHONE}
                onChange={e => handleFormChange(e)}
                error={!!errors[PROFILE_FORM_INPUTS.PHONE]}
                cypress_id={'businessPhoneNumberInput'}
              />
              <Grow in={!!errors[PROFILE_FORM_INPUTS.PHONE]}>
                <span className={classes.error}>
                  {errors[PROFILE_FORM_INPUTS.PHONE]}
                </span>
              </Grow>
            </div>
            <div
              className={classnames(classes.infoItem, 'makeStyles-infoItem')}
            >
              <FieldLabel
                label="Repeat password"
                mandatory
                cypress_id="repeatPasswInputTitle"
              />
              <OutlinedInput
                className={classes.value}
                value={userData.password2}
                name={PROFILE_FORM_INPUTS.PASSWORD2}
                type={showPassword2 ? 'text' : 'password'}
                onChange={handleFormChange}
                inputProps={{
                  autocomplete: 'new-password',
                  form: {
                    autocomplete: 'off',
                  },
                }}
                endAdornment={
                  <InputAdornment position="end">
                    <IconButton
                      onClick={() => setShowPassword2(!showPassword2)}
                      edge="end"
                    >
                      {showPassword2 ? (
                        <VisibilityOnIcon />
                      ) : (
                        <VisibilityOffIcon />
                      )}
                    </IconButton>
                  </InputAdornment>
                }
                cypress_id={'repeatPasswordInput'}
              />
              <Grow in={!!errors[PROFILE_FORM_INPUTS.PASSWORD2]}>
                <span className={classes.error}>
                  {errors[PROFILE_FORM_INPUTS.PASSWORD2]}
                </span>
              </Grow>
            </div>
          </div>
        </div>
      </div>
      <div className={classes.buttonsContainer}>
        <button
          className={classes.profileButton}
          onClick={() => {
            history.goBack()
          }}
        >
          Cancel
        </button>
        <button
          className={classnames(classes.profileButton, classes.saveButton, {
            [classes.disabled]: disableSave,
          })}
          onClick={() => {
            handleSave(userData)
          }}
          disabled={disableSave}
        >
          Save
        </button>
      </div>
    </Fragment>
  )
}
